<script>
import { mapActions, mapState } from 'vuex'
import TransportReportResult from '../../components/TransportReportResult'
import TransportRouteResult from '../../components/TransportRouteResult'

export default {
  name: "TransferManifest",
  components: {
    TransportReportResult,
    TransportRouteResult,
  },
  mixins: [],
  props: {},
  data() {
    return {
      breadcrumbs: [
        { text: 'JWNETデータ取込', disabled: false, to: { name: 'DriverTransfers'}, exact: true },
        { text: 'JWNETデータ取込の詳細', disabled: true, to: '' }
      ],
      jwnet_manifest: null,
      tableHeaders: [
        { value: 'final_disposal_date', text: '最終処分終了日' },
        { value: 'name', text: '最終処分事業場' }
      ],
      headers: [
        {value: "level", text: "工程", width: "5%"},
        {value: "disposer", text: "処分事業者\r\n処分事業場\r\n住所", width: "20%"},
        {value: "report_before_disposal_weight", text: "処分前重量", width: "5%"},
        {value: "primary_disposal_method", text: "主たる処分方法\r\n処分方法", width: "15%"},
        {value: "report_after_disposal_weight", text: "処理後重量", width: "5%"},
        {value: "recycle_disposed_item", text: "処理後物の大分類\r\n処理後物の種類", width: "15%"},
        {value: "final_disposal", text: "最終処分", width: "10%"},
        {value: "input_final_disposal_date", text: "最終処分終了日", width: "10%"},
        {value: "comment", text: "備考", width: "15%"},
      ]
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      mode: 'mode',
    }),
    /**
     * JWNETデータ取込のルート詳細をTransportRouteResult用の形式に変換
     */
    transportRouteForm() {
      if (!this.jwnet_manifest) return null;
      return {
        transport_routes: {
          transport_route_sections: this.jwnet_manifest.manifest_transports.map(manifestTransport => ({
            section: manifestTransport.section,
            transport: {
              name: manifestTransport.transport.name,
              zip_code: manifestTransport.transport.zip_code,
              address: manifestTransport.transport.address,
              phone_number: manifestTransport.transport.phone_number,
              transport_permit_number: manifestTransport.transport.permit_number,
              subscriber_number: manifestTransport.transport.subscriber_number,
              report_transport_completed_date: manifestTransport.transport.report_transport_completed_date
            },
            trader: {
              transport_permit_number: manifestTransport.trader.transport_permit_number,
              subscriber_number: manifestTransport.trader.subscriber_number
            },
            trader_location: {
              name: manifestTransport.trader_location.name,
              zip_code: manifestTransport.trader_location.zip_code,
              address: manifestTransport.trader_location.address,
              phone_number: manifestTransport.trader_location.phone_number
            }
          })),
          disposer: this.jwnet_manifest.disposer,
          disposer_location: this.jwnet_manifest.disposer_location,
        }
      };
    },
    /**
     * 再資源化等の情報詳細の表示判定
     */
    showRecycleDisposalReport() {
      return (this.mode === 'transport_disposal' || this.mode === 'disposal') && this.jwnet_manifest.manifest_recycle_disposal_reports.some(
        report => ['last_report', 'final_disposal_report'].includes(report.report_type)
      )
    },
  },
  watch: {},
  created() {
    this.fetchTransfer({id: this.$route.params.id}).then((content) => {
      this.jwnet_manifest = content;
    });
  },
  methods: {
    ...mapActions("DriverTransfer", {
      fetchTransfer: "show"
    }),
    backButtonClickEvent () {
      this.$router.push( { name: 'DriverTransfers' } )
    },
  }
};
</script>

<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />

    <v-row>
      <v-col cols="12" md="6">
        <h2>
          JWNETデータ取込の詳細
        </h2>
      </v-col>
    </v-row>
    <v-card
      v-if="jwnet_manifest"
      flat
      class="rounded-card"
    >
      <v-card-text>
        <v-row>
          <v-col
            cols="12" md="3"
          >
            <div class="overline">
              マニフェスト
            </div>
            <h4>
              {{ jwnet_manifest.level === 'first_manifest' ? "１" : "２" }}次マニフェスト{{ jwnet_manifest.manifest_type | manifest_type_to_label_light }}
            </h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>

      <!-- 排出事業者 -->
      <v-card-title>
        <span style="color: #0074BA">排出事業者情報</span>&emsp;
      </v-card-title>
      <v-card-text>
        <!-- 会社名 -->
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              会社名
            </div>
            <h4>{{ jwnet_manifest.supplier.name }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /会社名 -->
        <!-- 住所 -->
        <v-row>
          <v-col cols="12">
            <div class="overline">
              住所
            </div>
            <h4>
              〒{{ jwnet_manifest.supplier.zip_code }}&emsp;
              {{ jwnet_manifest.supplier.address }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /住所 -->
        <!-- 電話番号／引渡担当者／登録担当者 -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              電話番号
            </div>
            <h4>{{ jwnet_manifest.supplier.phone_number || '-' }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              引渡担当者名
            </div>
            <h4>{{ jwnet_manifest.deliver_staff || '-' }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              登録担当者名
            </div>
            <h4>{{ jwnet_manifest.register_staff || '-' }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /電話番号／引渡担当者／登録担当者 -->
      </v-card-text>
      <!-- /排出事業者 -->

      <!-- 引渡し日 -->
      <v-card-title>
        <span style="color: #0074BA">引渡し日</span>&emsp;
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              引渡し日
            </div>
            <h4>{{ jwnet_manifest.collected_date | date_format }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>
      <!-- /引渡し日 -->

      <!-- 連絡番号１／連絡番号２／連絡番号３ -->
      <v-card-title>
        <span style="color: #0074BA">連絡番号</span>&emsp;
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              連絡番号１
            </div>
            <h4>{{ jwnet_manifest.contact_number_1 || '-' }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              連絡番号２
            </div>
            <h4>{{ jwnet_manifest.contact_number_2 || '-' }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              連絡番号３
            </div>
            <h4>{{ jwnet_manifest.contact_number_3 || '-' }}</h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>
      <!-- /連絡番号１／連絡番号２／連絡番号３ -->

      <!-- 事業場情報 -->
      <v-card-title>
        <span style="color: #0074BA">排出事業場情報</span>&emsp;
      </v-card-title>
      <v-card-text>
        <!-- 事業場名 -->
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              事業場名
            </div>
            <h4>{{ jwnet_manifest.supplier_location.name }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /事業場名 -->
        <!-- 事業場住所 -->
        <v-row>
          <v-col cols="12">
            <div class="overline">
              住所
            </div>
            <h4>
              〒{{ jwnet_manifest.supplier_location.zip_code }}&emsp;
              {{ jwnet_manifest.supplier_location.address }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /事業場住所 -->
        <!-- 電話番号 -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              電話番号
            </div>
            <h4>{{ jwnet_manifest.supplier_location.phone_number || '-' }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /電話番号 -->
      </v-card-text>
      <!-- /事業場情報 -->

      <!-- 運搬情報 -->
      <v-card-title>
        <span style="color: #0074BA">運搬情報</span>
      </v-card-title>
      <v-card-text>
        <!-- 運搬方法・運搬担当者・車両番号 -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              運搬担当者
            </div>
            <h4>
              {{ jwnet_manifest.transport_user_name }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              運搬方法
            </div>
            <h4>
              {{ jwnet_manifest.transportation_name }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              車両番号
            </div>
            <h4>
              {{ jwnet_manifest.vehicle_number }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /運搬方法・運搬担当者・車両番号 -->

      </v-card-text>
      <!-- /運搬情報 -->


      <!-- 廃棄物情報 -->
      <v-card-title class="">
        <v-tabs background-color="blue-grey lighten-4 mb-4">
          <v-tab>{{ jwnet_manifest.item_name }}</v-tab>
        </v-tabs>
        <span style="color: #0074BA">廃棄物情報</span>&emsp;
      </v-card-title>
      <v-card-text>
        <!-- マニフェスト番号 -->
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              マニフェスト番号
            </div>
            <h4>{{ jwnet_manifest.manifest_no || '-' }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              取込支店/営業所名
            </div>
            <h4>{{ jwnet_manifest.tenant_name || '-' }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /マニフェスト番号 -->
        <!-- 取扱品目／廃棄物の名称 -->
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              取扱品目
            </div>
            <h4>{{ jwnet_manifest.item_name }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              廃棄物の名称
            </div>
            <h4>{{ jwnet_manifest.waste_name }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /取扱品目／廃棄物の名称 -->
        <!-- 数量・数量の確定者／荷姿・荷姿の数量 -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              数量
            </div>
            <h4>{{ jwnet_manifest.quantity }}&nbsp;{{ jwnet_manifest.quantity_unit_name }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              数量の確定者
            </div>
            <h4>{{ jwnet_manifest.quantity_confirm_name }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              荷姿
            </div>
            <h4>{{ jwnet_manifest.packing_name || '-' }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              荷姿の数量
            </div>
            <h4>{{ jwnet_manifest.packing_quantity }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /数量・数量の確定者／荷姿・荷姿の数量 -->
        <!-- 有害物質 -->
        <template
          v-if="jwnet_manifest.item_use_harmful"
        >
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <div class="overline">
                有害物質１
              </div>
              <h4>{{ jwnet_manifest.hazardous_substance_1_name || '-' }}</h4>
              <v-divider />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <div class="overline">
                有害物質２
              </div>
              <h4>{{ jwnet_manifest.hazardous_substance_2_name || '-' }}</h4>
              <v-divider />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <div class="overline">
                有害物質３
              </div>
              <h4>{{ jwnet_manifest.hazardous_substance_3_name || '-' }}&nbsp;</h4>
              <v-divider />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <div class="overline">
                有害物質４
              </div>
              <h4>{{ jwnet_manifest.hazardous_substance_4_name || '-' }}&nbsp;</h4>
              <v-divider />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <div class="overline">
                有害物質５
              </div>
              <h4>{{ jwnet_manifest.hazardous_substance_5_name || '-' }}&nbsp;</h4>
              <v-divider />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <div class="overline">
                有害物質６
              </div>
              <h4>{{ jwnet_manifest.hazardous_substance_6_name || '-' }}&nbsp;</h4>
              <v-divider />
            </v-col>
          </v-row>
        </template>
        <!-- /有害物質 -->
        <!-- 確定数量 -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              確定数量（確定数量の単位）
            </div>
            <h4>{{ jwnet_manifest.report_transport_quantity }}&nbsp;{{ jwnet_manifest.report_transport_quantity_unit_name }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /確定数量 -->
      </v-card-text>
      <!-- 廃棄物情報 -->

      <!-- 運搬ルート -->
      <v-card-title>
        <span style="color: #0074BA">運搬ルート</span>&emsp;
      </v-card-title>
      <v-card-text>
        <transport-route-result
          :custom-mode="true"
          :form="transportRouteForm"
          :emission="jwnet_manifest.supplier"
        />
        <!-- 処分方法 -->
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              処分方法
            </div>
            <h4>
              {{ jwnet_manifest.disposal_method_name }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /処分方法 -->
      </v-card-text>

      <!-- 運搬終了報告 1〜５-->
      <transport-report-result :manifest-transports="jwnet_manifest.manifest_transports" />
      <!-- /運搬終了報告 1〜５-->

      <!-- 処分報告 -->
      <v-card-title>
        <span style="color: #0074BA">処分報告</span>&emsp;
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              報告区分
            </div>
            <h4>
              {{ jwnet_manifest.disposal_report.disposal_report_type_name }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              処分終了日
            </div>
            <h4>
              {{ jwnet_manifest.disposal_report.disposal_report_end_date | date_format }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              処分担当者
            </div>
            <h4>
              {{ jwnet_manifest.disposal_report.disposal_report_person }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              報告担当者
            </div>
            <h4>
              {{ jwnet_manifest.disposal_report.disposal_report_reporter }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              廃棄物受領日
            </div>
            <h4>
              {{ jwnet_manifest.disposal_report.disposal_report_receipt_date | date_format }}&nbsp;&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              運搬担当者
            </div>
            <h4>
              {{ jwnet_manifest.disposal_report.disposal_report_driver }}&nbsp;&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              車両番号
            </div>
            <h4>
              {{ jwnet_manifest.disposal_report.disposal_report_vehicle_number }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              受入量
            </div>
            <h4>{{ jwnet_manifest.disposal_report.disposal_report_amount }}&nbsp;{{ jwnet_manifest.disposal_report.disposal_report_amount_unit_name }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              処分終了報告日時
            </div>
            <h4>
              {{ jwnet_manifest.disposal_report.disposal_end_at | unix_date_format }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              最終処分終了日
            </div>
            <h4>
              {{ jwnet_manifest.disposal_report.disposal_end_last_date }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              最終処分終了報告日時
            </div>
            <h4>
              {{ jwnet_manifest.disposal_report.final_disposal_end_at }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="overline">
              処分備考
            </div>
            <h4>
              {{ jwnet_manifest.disposal_report.disposal_report_remarks }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>
      <!-- /処分報告 -->

      <!-- 最終処分 -->
      <v-card-title>
        <span style="color: #0074BA">最終処分</span>&emsp;
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="tableHeaders"
          :items="jwnet_manifest.final_disposals"
          disable-sort
          hide-default-footer
          no-data-text=" "
        >
          <template v-slot:[`item.name`]="{item}">
            {{ item.name }}
            <v-tooltip
              top
              :open-on-hover="false"
            >
              <template #activator="{ on }">
                <v-btn
                  v-if="item.address"
                  icon
                  small
                  retain-focus-on-click
                  @click="on.click"
                  @blur="on.blur"
                >
                  <v-icon small>
                    mdi-map-marker-outline
                  </v-icon>
                </v-btn>
              </template>
              <small
                v-if="item.address"
              >
                {{ item.address }}
              </small>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
      <!-- /最終処分 -->

      <!-- JWNET備考 -->
      <v-card-title>
        <span style="color: #0074BA">JWNET備考</span>&emsp;
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              備考１
            </div>
            <h4>
              {{ jwnet_manifest.note_1 }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              備考２
            </div>
            <h4>
              {{ jwnet_manifest.note_2 }}&nbsp;&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              備考３
            </div>
            <h4>
              {{ jwnet_manifest.note_3 }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              備考４
            </div>
            <h4>
              {{ jwnet_manifest.note_4 }}&nbsp;&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              備考５
            </div>
            <h4>
              {{ jwnet_manifest.note_5 }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>
      <!-- /JWNET備考 -->

      <!-- 再資源化等の情報詳細 -->
      <template v-if="showRecycleDisposalReport">
        <v-card-title>
          <span style="color: #0074BA">再資源化等の情報詳細</span>
        </v-card-title>
        <v-card-text>
          <!-- 基準重量・重量 -->
          <v-row>
            <v-col cols="12" md="3">
              <div class="overline">
                基準重量
              </div>
              <h4>
                {{ jwnet_manifest.reported_standard_quantity_type_name || '-' }}&nbsp;
              </h4>
              <v-divider />
            </v-col>
            <v-col cols="12" md="3">
              <div class="overline">
                重量
              </div>
              <h4>
                {{ jwnet_manifest.reported_quantity ? `${jwnet_manifest.reported_quantity}kg` : '-' }}
              </h4>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /基準重量・重量 -->
          <div class="mt-2">
            <recycle-step-table
              :headers="headers"
              :result-list="jwnet_manifest.manifest_recycle_disposal_reports || []"
              :reference-only="true"
            />
          </div>
        </v-card-text>
      </template>
      <!-- /再資源化等の情報詳細 -->
      <v-card-actions>
      <v-spacer />
      <v-btn
        @click="backButtonClickEvent"
      >
        戻る
      </v-btn>
    </v-card-actions>
    </v-card>


  </v-container>
</template>


